import { api } from '../main-api/apiClient';

// Tenant Technician API services - for patient management and recording link sending
export const tenantTechnicianAPI = {
  // Patient Management
  getPatients: () => api.get('/tenant-technician/patients'),
  
  getPatient: (patientId) => api.get(`/tenant-technician/patients/${patientId}`),
  
  // Recording Management
  sendRecordingLink: (patientId, channel, customMessage = null) => {
    const formData = new FormData();
    formData.append('channel', channel);
    if (customMessage && customMessage.trim()) {
      formData.append('custom_message', customMessage);
    }
    return api.post(`/tenant-technician/patients/${patientId}/send-recording-link`, formData);
  },
  
  // Patient Vitals
  getPatientVitals: (patientId) => api.get(`/tenant-technician/patients/${patientId}/vitals`)
};

export default tenantTechnicianAPI;